import styled, {css} from 'styled-components';

export const formGrid = css`
	display: grid;
	grid-template-columns: repeat(var(--cols), 1fr);
	grid-template-rows: auto;
	min-height: 0;
	gap: var(--spacing-xx-large);
`;

export default styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	& > .customScrollbar {
		padding: 0 var(--template-padding-sides);
		flex: 1;
		& > div {
			--cols: 3;
			${formGrid}
			padding: var(--spacing-xx-large) 0;
			.instructional,
			.engagements {
				grid-column-end: span var(--cols);
			}
		}
	}
	& > footer {
		border-top: var(--template-separator);
		flex-shrink: 0;
	}
`;
